import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button from '../../../../../Button'
import { APPLICANT_REVEAL_IDENTITY_TRANSITION } from '../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import {
  APPLICANT_CONFIRMED_TRANSITION,
  useApplicantConfirmedTransition,
  useApplicantMoveToScreening,
} from '../../../RentalPortalApplicantProfileHeaderStageSelect'
import {
  QA_NAME_APPLICANT_IDENTITY_BREAK_GLASS_REVEAL,
  QA_NAME_APPLICANT_IDENTITY_REVEAL,
} from '../ApplicantIdentityWidget.constants'
import {
  getApplicantIdentityRevealTooltipKey,
  getHasApplicantIdentityBreakGlassReveal,
  getHasApplicantIdentityReveal,
} from '../ApplicantIdentityWidget.utils'

import * as styles from './ApplicantIdentityWidgetRevealActions.module.css'

function ApplicantIdentityWidgetRevealActions() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const { handleClickMoveToScreening, isMovingToScreening } =
    useApplicantMoveToScreening()

  const { handleClickConfirmedTransition, isTransitionSaving } =
    useApplicantConfirmedTransition()

  function handleClickBreakGlassReveal() {
    handleClickConfirmedTransition(
      APPLICANT_CONFIRMED_TRANSITION[APPLICANT_REVEAL_IDENTITY_TRANSITION]
    )
  }

  const revealTooltipKey = getApplicantIdentityRevealTooltipKey(applicantData)

  const isSaving = isMovingToScreening || isTransitionSaving

  const isRevealDisabled = Boolean(revealTooltipKey) || isSaving

  return (
    <div className={styles.ApplicantIdentityWidgetRevealActions}>
      {getHasApplicantIdentityReveal(applicantData) ? (
        <Button.Contained
          disabled={isRevealDisabled}
          qaName={QA_NAME_APPLICANT_IDENTITY_REVEAL}
          text={t('RentalPortal.ApplicantProfileStageMoveToScreeningBtnKey')}
          tooltip={revealTooltipKey ? t(revealTooltipKey) : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={handleClickMoveToScreening}
        />
      ) : null}
      {getHasApplicantIdentityBreakGlassReveal(applicantData) ? (
        <Button.Outlined
          disabled={isSaving}
          qaName={QA_NAME_APPLICANT_IDENTITY_BREAK_GLASS_REVEAL}
          text={t('RentalPortal.ApplicantProfileRevealIdentityBtnKey')}
          onClick={handleClickBreakGlassReveal}
        />
      ) : null}
    </div>
  )
}

export default ApplicantIdentityWidgetRevealActions
